// Dictionnaire français — UI globale
export const fr = {
  nav: {
    home: 'Accueil',
    house: 'La maison',
    collections: 'Collections',
    reverie: 'Rêverie',
    fabrication: 'La fabrication',
    contact: 'Nous contacter',
    legal: 'Mentions légales',
    privacy: 'Politique de confidentialité',
    menu: 'Menu',
    close: 'Fermer',
  },
  footer: {
    navigation: 'Navigation',
    contact: 'Contact',
    follow: 'Suivez-nous',
    rights: 'Tous droits réservés',
  },
  common: {
    back: 'Retour',
    discover: 'Découvrir',
    contactUs: 'Nous écrire',
    loading: 'Chargement...',
    close: 'Fermer',
  },
  home: {
    heroTagline: 'Born from Memory',
    heroDescription: 'Des bijoux pensés comme des fragments de mémoire.',
    phase2: 'Tout commence par une pierre...',
    sylvieIntroLine1: 'Une émotion, une lumière, un souvenir,',
    sylvieIntroLine2: 'un instant vécu quelque part dans le monde...',
    sylvieTitle: 'La pierre devient bijou...',
    savoirFaireLine1: 'À porter',
    savoirFaireLine2: 'À transmettre',
    ctaText1: 'Des pièces réalisées au gré des pierres choisies.',
    ctaText2: 'Éditions confidentielles, numérotées.',
    ctaButton: 'Découvrir la collection',
  },
  collection: {
    title: 'Rêverie',
    introP1Part1: ' est une collection d\'instants suspendus. Elle évoque les moments où la pensée vagabonde...',
    introP2: 'C\'est à Bangkok, là où tout a commencé pour Pernety, que nous avons d\'abord rêvé.',
    customP1: 'Des pièces réalisées au gré des pierres choisies, sur commande.',
    customP2: 'Recherche de pierres sur demande.',
    // Overlay produit
    back: 'Retour',
    stone: 'Pierre',
    origin: 'Origine',
    size: 'Taille',
    availability: 'Disponibilité',
    onOrder: 'Sur commande',
    pieceCount: (n) => `${n} pièce${n > 1 ? 's' : ''}`,
    relatedTitle: 'Irait bien avec',
    ctaContact: 'Nous écrire',
    untitledPiece: 'Titre à définir',
    descriptionPlaceholder: 'Description à définir depuis l\'interface admin',
    notFound: 'Pièce introuvable',
    backToCollection: 'Retour à la collection',
  },
  legal: {
    heroTitle: 'Mentions légales',
    lastUpdate: 'Dernière mise à jour',
    s1Title: '1. Éditeur du site',
    s1Intro: 'Le site',
    s1Edited: 'est édité par :',
    brand: 'Nom commercial',
    responsible: 'Responsable',
    legalStatus: 'Statut juridique',
    address: 'Adresse du siège',
    siret: 'Numéro SIRET',
    apeCode: 'Code APE/NAF',
    vat: 'Numéro de TVA intracommunautaire',
    capital: 'Capital social',
    rcs: 'RCS',
    phoneLabel: 'Téléphone',
    emailLabel: 'Email',
    s2Title: '2. Directeur de la publication',
    s2P: (name, role) => `Le directeur de la publication du site est ${name}, en sa qualité de ${role}.`,
    s3Title: '3. Hébergement',
    s3Intro: 'Le site est hébergé par :',
    hostCompany: 'Société',
    hostAddress: 'Adresse',
    hostPhone: 'Téléphone',
    hostWebsite: 'Site web',
    s4Title: '4. Propriété intellectuelle',
    s4P1: 'L\'ensemble des éléments présents sur le site (textes, photographies, illustrations, graphismes, logos, marques, mises en page, créations, vidéos, sons et plus généralement tout contenu) est la propriété exclusive de Pernety ou de ses partenaires et est protégé par le droit français et international relatif à la propriété intellectuelle.',
    s4P2: 'Toute reproduction, représentation, modification, publication, transmission, dénaturation, totale ou partielle, du site ou de son contenu, par quelque procédé que ce soit, et sur quelque support que ce soit, est interdite sans autorisation écrite préalable de Pernety. Toute exploitation non autorisée constituerait une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la propriété intellectuelle.',
    s4P3: (owner) => `La marque « Pernety » ainsi que le logo associé sont la propriété de ${owner}.`,
    s5Title: '5. Crédits',
    creditsDev: 'Conception et développement',
    creditsPhoto: 'Photographies',
    creditsDesign: 'Identité graphique',
    s6Title: '6. Limitation de responsabilité',
    s6P1: 'Pernety s\'efforce d\'assurer au mieux de ses possibilités l\'exactitude et la mise à jour des informations diffusées sur le site. Toutefois, Pernety ne peut garantir l\'exactitude, la précision ou l\'exhaustivité des informations mises à disposition sur le site.',
    s6P2: 'En conséquence, Pernety décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur le site, ainsi que pour tout dommage résultant d\'une intrusion frauduleuse d\'un tiers.',
    s6P3: 'L\'utilisateur reconnaît utiliser le site sous sa seule et entière responsabilité.',
    s7Title: '7. Liens hypertextes',
    s7P1: 'Le site peut contenir des liens hypertextes vers d\'autres sites. Pernety n\'exerce aucun contrôle sur ces sites et n\'assume aucune responsabilité quant à leur contenu, à leur disponibilité ou aux pratiques qu\'ils mettent en œuvre concernant les données personnelles.',
    s7P2: 'La création de liens vers le site nécessite l\'autorisation préalable et écrite de Pernety.',
    s8Title: '8. Données personnelles',
    s8P: 'Le traitement des données à caractère personnel collectées sur le site est détaillé dans la',
    s8Link: 'Politique de confidentialité',
    s8End: ', qui fait partie intégrante des présentes mentions légales.',
    s9Title: '9. Loi applicable et juridiction compétente',
    s9P: 'Les présentes mentions légales sont soumises au droit français. En cas de litige relatif à l\'utilisation du site, et à défaut de résolution amiable, les tribunaux français seront seuls compétents.',
    s10Title: '10. Contact',
    s10P: (email) => `Pour toute question relative aux présentes mentions légales, vous pouvez nous écrire à l'adresse ${email} ou via le formulaire de contact.`,
    s10Form: 'formulaire de contact',
  },
  privacy: {
    heroTitle: 'Politique de confidentialité',
    lastUpdate: 'Dernière mise à jour',
    preambleTitle: 'Préambule',
    preambleP1: 'La présente politique de confidentialité a pour objet de vous informer, de manière transparente, sur la manière dont Pernety collecte, utilise et protège vos données à caractère personnel lorsque vous visitez le site',
    preambleP1End: ' ou interagissez avec nous.',
    preambleP2: 'Cette politique est conforme au Règlement (UE) 2016/679 du Parlement européen et du Conseil du 27 avril 2016 (« RGPD ») ainsi qu\'à la loi française « Informatique et Libertés » modifiée du 6 janvier 1978.',
    s1Title: '1. Responsable du traitement',
    s1Intro: 'Le responsable du traitement de vos données est :',
    s1Identity: 'Identité',
    s1Status: 'Statut',
    s1Address: 'Adresse',
    s1Siret: 'SIRET',
    s1Email: 'Email',
    s1Phone: 'Téléphone',
    s1NoDpo: 'Pernety n\'a pas désigné de Délégué à la Protection des Données (DPO) car la nomination n\'est pas obligatoire au regard de l\'activité et du volume de données traitées. Toute demande relative à vos données personnelles peut être adressée directement au responsable du traitement aux coordonnées ci-dessus.',
    s2Title: '2. Données personnelles collectées',
    s2Intro: 'Les données suivantes peuvent être collectées sur le site :',
    s2_1Title: '2.1 Via le formulaire de contact',
    s2_1L1: '— Nom et prénom',
    s2_1L2: '— Adresse email',
    s2_1L3: '— Numéro de téléphone (facultatif)',
    s2_1L4: '— Type de demande (renseignement, commande sur mesure, prise de rendez-vous, autre)',
    s2_1L5: '— Type de bijou souhaité, budget envisagé, occasion (facultatifs)',
    s2_1L6: '— Contenu du message',
    s2_2Title: '2.2 Données techniques',
    s2_2L1: '— Adresse IP (collectée par les logs du serveur à des fins de sécurité)',
    s2_2L2: '— Type de navigateur et système d\'exploitation',
    s2_2L3: '— Pages visitées et date/heure de visite',
    s2NoSensitive: 'Aucune donnée sensible au sens de l\'article 9 du RGPD (origine raciale ou ethnique, opinions politiques, convictions religieuses, données de santé, etc.) n\'est collectée.',
    s3Title: '3. Finalités du traitement',
    s3Intro: 'Vos données sont collectées et traitées pour les finalités suivantes :',
    s3L1: 'Répondre aux demandes de contact, de devis ou de prise de rendez-vous adressées via le formulaire',
    s3L2: 'Gérer la relation client et les éventuelles commandes sur mesure',
    s3L3: 'Assurer la sécurité, la disponibilité et le bon fonctionnement du site',
    s3L4: 'Respecter nos obligations légales et réglementaires (notamment comptables et fiscales)',
    s3End: 'Vos données ne font l\'objet d\'aucune décision automatisée ni de profilage.',
    s4Title: '4. Bases légales du traitement',
    s4Intro: 'Conformément à l\'article 6 du RGPD, le traitement de vos données repose sur les bases légales suivantes :',
    s4L1Strong: 'Consentement',
    s4L1: ' (art. 6.1.a) : lorsque vous remplissez et soumettez le formulaire de contact',
    s4L2Strong: 'Exécution d\'un contrat ou de mesures précontractuelles',
    s4L2: ' (art. 6.1.b) : pour donner suite à vos demandes de devis ou de commande',
    s4L3Strong: 'Intérêt légitime',
    s4L3: ' (art. 6.1.f) : pour assurer la sécurité du site et de notre système d\'information',
    s4L4Strong: 'Obligation légale',
    s4L4: ' (art. 6.1.c) : pour respecter les durées de conservation imposées par la loi (notamment en matière comptable)',
    s5Title: '5. Durée de conservation',
    s5Intro: 'Vos données sont conservées pendant les durées suivantes :',
    s5L1Strong: 'Messages de contact :',
    s5L1: ' 3 ans à compter du dernier échange, conformément aux recommandations de la CNIL en matière de prospection',
    s5L2Strong: 'Données de clients (commandes) :',
    s5L2: ' 5 ans après la fin de la relation contractuelle, en conformité avec les obligations comptables (art. L.123-22 du Code de commerce)',
    s5L3Strong: 'Logs de connexion :',
    s5L3: ' 12 mois maximum (recommandation CNIL)',
    s5End: 'Au-delà de ces durées, les données sont soit supprimées, soit anonymisées à des fins statistiques.',
    s6Title: '6. Destinataires de vos données',
    s6P1: 'Vos données sont destinées exclusivement à Pernety et ne sont en aucun cas vendues, louées ou cédées à des tiers à des fins commerciales.',
    s6P2: 'Elles peuvent toutefois être communiquées aux destinataires suivants, dans la limite stricte de leurs missions :',
    s6L1Strong: 'Sous-traitants techniques',
    s6L1: ' agissant sur instruction du responsable du traitement, dans le cadre d\'un contrat conforme à l\'article 28 du RGPD :',
    s6OvhStrong: 'OVH SAS',
    s6Ovh: ' (hébergement du serveur) — France',
    s6MongoStrong: 'MongoDB Atlas',
    s6Mongo: ' (hébergement de la base de données) — ',
    s6Auth: 'Autorités administratives ou judiciaires',
    s6AuthEnd: ', sur réquisition légale',
    s7Title: '7. Transferts de données hors Union européenne',
    s7P1: 'Si la base de données MongoDB Atlas est hébergée dans un pays situé hors de l\'Union européenne, ce transfert est encadré par les',
    s7P1Strong: 'Clauses Contractuelles Types',
    s7P1End: ' approuvées par la Commission européenne, garantissant un niveau de protection équivalent au RGPD.',
    s7P2: 'Le site charge également des polices typographiques depuis Google Fonts (Playfair Display, Cormorant Garamond). Cela peut entraîner la transmission de votre adresse IP aux serveurs de Google LLC. Ces transferts sont encadrés par le',
    s7P2Strong: 'Data Privacy Framework',
    s7P2End: ' (DPF) entre l\'UE et les États-Unis.',
    s8Title: '8. Vos droits',
    s8Intro: 'Conformément aux articles 15 à 22 du RGPD, vous disposez des droits suivants sur vos données personnelles :',
    s8L1Strong: 'Droit d\'accès',
    s8L1: ' : obtenir la confirmation que vos données sont traitées et en obtenir une copie',
    s8L2Strong: 'Droit de rectification',
    s8L2: ' : faire corriger des données inexactes ou incomplètes',
    s8L3Strong: 'Droit à l\'effacement',
    s8L3: ' (« droit à l\'oubli ») : faire supprimer vos données dans les cas prévus par la loi',
    s8L4Strong: 'Droit à la limitation du traitement',
    s8L4: ' : suspendre temporairement le traitement de vos données',
    s8L5Strong: 'Droit d\'opposition',
    s8L5: ' : vous opposer au traitement pour des motifs tenant à votre situation particulière',
    s8L6Strong: 'Droit à la portabilité',
    s8L6: ' : recevoir vos données dans un format structuré et lisible par machine',
    s8L7Strong: 'Droit de définir des directives post-mortem',
    s8L7: ' sur le sort de vos données après votre décès',
    s8L8Strong: 'Droit de retirer votre consentement',
    s8L8: ' à tout moment, sans que cela n\'affecte la licéité du traitement antérieur',
    s8End: (email) => `Pour exercer ces droits, vous pouvez nous contacter à l'adresse ${email} en justifiant de votre identité. Nous nous engageons à répondre dans un délai d'un mois à compter de la réception de votre demande, conformément à l'article 12 du RGPD.`,
    s9Title: '9. Réclamation auprès de la CNIL',
    s9P: 'Si vous estimez, après nous avoir contactés, que vos droits ne sont pas respectés, vous avez la possibilité d\'adresser une réclamation à la Commission Nationale de l\'Informatique et des Libertés (CNIL) :',
    s9Address: 'Adresse',
    s9Phone: 'Téléphone',
    s9Web: 'Site web',
    s10Title: '10. Sécurité des données',
    s10Intro: 'Pernety met en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données contre la perte, la destruction, la divulgation, l\'altération ou l\'accès non autorisé, notamment :',
    s10L1: 'Chiffrement des communications via HTTPS (certificat SSL/TLS)',
    s10L2: 'Hashage cryptographique des mots de passe administrateur (bcrypt)',
    s10L3: 'Restriction des accès aux seules personnes autorisées',
    s10L4: 'Sauvegardes régulières et hébergement sur infrastructure sécurisée',
    s10L5: 'En-têtes de sécurité HTTP (Helmet)',
    s10End: 'En cas de violation de données susceptible d\'engendrer un risque élevé pour vos droits et libertés, vous serez informé conformément à l\'article 34 du RGPD.',
    s11Title: '11. Modifications de la présente politique',
    s11P: 'La présente politique peut être modifiée à tout moment, notamment pour s\'adapter à l\'évolution de la législation ou des activités de Pernety. La date de dernière mise à jour figure en tête du présent document. Nous vous invitons à la consulter régulièrement.',
    s12Title: '12. Contact',
    s12P1: (email) => `Pour toute question relative à la présente politique ou au traitement de vos données personnelles, vous pouvez nous écrire à l'adresse ${email} ou via le formulaire de contact.`,
    s12Form: 'formulaire de contact',
    s12P2: 'Les mentions légales du site complètent la présente politique.',
    s12LegalLink: 'mentions légales',
    placeholder: (hint) => `[À compléter : ${hint}]`,
  },
  login: {
    privateArea: 'Espace privé',
    emailPlaceholder: 'Email',
    passwordPlaceholder: 'Mot de passe',
    submit: 'Accéder',
    submitting: 'Connexion...',
    footer: 'Site en cours de développement',
  },
  contact: {
    heroTitle: 'Un bijou commence par un échange',
    infoLead: 'Chaque message est lu avec attention.',
    emailLabel: 'Email',
    instagramLabel: 'Instagram',
    appointmentLabel: 'Sur rendez-vous',
    // Formulaire
    fullName: 'Nom complet',
    fullNamePlaceholder: 'Votre nom',
    emailPlaceholder: 'votre@email.com',
    phone: 'Téléphone',
    phonePlaceholder: 'Votre numéro',
    yourMessage: 'Votre message',
    requiredHint: '* Champs obligatoires',
    submit: 'Envoyer',
    submitting: 'Envoi en cours',
    // Validation
    errorName: 'Veuillez indiquer votre nom',
    errorEmailMissing: 'Veuillez indiquer votre email',
    errorEmailInvalid: 'L\'adresse email n\'est pas valide',
    errorMessage: 'Veuillez écrire un message',
    errorGeneric: 'Une erreur est survenue. Réessayez ou écrivez-nous directement à contact@pernetyparis.com',
    // Succès
    successTitle: 'Message envoyé',
    successDearClient: 'cher(e) client(e)',
    successThanks: (name) => `Merci pour votre message, ${name}.`,
    successReply: 'Je vous répondrai dans les meilleurs délais pour convenir d\'un rendez-vous.',
    sendAnother: 'Envoyer un autre message',
  },
  fabrication: {
    heroTitle: 'La fabrication',
    heroSubtitle: 'Un voyage artisanal',
    s1Title: 'Tout commence par une pierre,',
    s1P1: 'Rencontrée sur les marchés d\'Asie du Sud-Est, particulièrement à Bangkok, hub mondial des pierres de couleur, haut lieu du savoir-faire lapidaire et joaillier depuis plusieurs générations.',
    s1P2: 'Entre mon atelier parisien où je laisse courir mon imagination, et celui de mon artisan joaillier partenaire en Thaïlande, le bijou naît autour de la pierre qui l\'inspire.',
    s2Title: 'En toute transparence.',
    s2Intro: 'Chez Pernety, la transparence et la confiance nous tiennent à cœur.',
    s2P1: 'Chaque bijou s\'accompagne d\'une fiche détaillant la nature de sa pierre, son origine, ainsi que les conseils pour en prendre soin.',
    s2P2: 'Je sélectionne moi-même les pierres auprès de partenaires de confiance.',
    s2P3: 'Les pierres exceptionnelles sont accompagnées d\'un certificat d\'un laboratoire indépendant.',
    s2P4: 'L\'or que nous utilisons est issu de circuits contrôlés. Notre démarche s\'inscrit dans une volonté de responsabilité et d\'amélioration continue, avec pour objectif un approvisionnement toujours plus vertueux.',
  },
  laMaison: {
    heroTitle: 'La Maison',
    identityP1Start: 'Pernety est une maison de joaillerie qui imagine des bijoux pensés comme des ',
    identityP1Em: 'fragments de mémoire',
    identityP1Middle: '. ',
    identityP1Strong: 'Chaque création naît d\'un souvenir',
    identityP1End: ', d\'une émotion, d\'une lumière particulière, d\'un instant vécu quelque part dans le monde.',
    identityP2: 'Héritage de la terre, nos pierres sont choisies avec soin pour leur caractère unique, leur éclat singulier. Chaque bijou devient ainsi une présence intime à porter et à transmettre.',
    paris: 'Paris',
    bangkok: 'Bangkok',
    world: 'Le Monde',
    creatorTitle: 'La créatrice',
    creatorSubtitle: 'Un regard guidé par la pierre...',
    bioP1: 'Gemmologue, j\'ai été formée au Laboratoire Français de Gemmologie à Paris puis à l\'Asian Institute of Gemological Studies à Bangkok, où je me suis spécialisée dans les pierres de couleur.',
    bioP2: 'Curieuse et passionnée, je continue d\'enrichir mes connaissances et d\'affiner mon regard sur les gemmes. Mes créations naissent toujours d\'une pierre qui m\'inspire particulièrement, autour de laquelle le bijou prend forme.',
  },
};
